export const iconFontAwesomeUsersPeopleChildDress = (
	<i className="fa-solid fa-child-dress"></i>
);
